var $ = require('jquery')
  , ajaxEngageCurrentGame = require('apis/ajaxEngageCurrentGame')
  , openAlert = require('mobile/ui/openAlert')
  , EngageForm = require('mobile/widgets/EngageForm')

module.exports = function(gameCode, channelType, triggerBtn) {
  ajaxEngageCurrentGame(gameCode, channelType)
    .done(function(userInfo) {
      var formDiaog = new EngageForm({
        userInfo: userInfo,
        triggerBtn: triggerBtn
      })

      formDiaog.render().open()
    })
    .fail(function(message) {
      return openAlert({ content: message || ERROR_MSG })
    })
}